// extracted by mini-css-extract-plugin
export default {"loadingContainer":"PageOverlayLoading_loadingContainer__2z78G","loadingText":"PageOverlayLoading_loadingText__Phg6f"};